/**
 * Utilitaires pour manipuler le HTML
 */

/**
 * Convertit du HTML en texte brut en supprimant les balises
 * @param {string} html - Chaîne HTML
 * @returns {string} - Texte brut
 */
export const stripHtml = (html) => {
  if (!html) return '';

  // Créer un élément temporaire pour parser le HTML
  const temp = document.createElement('div');
  temp.innerHTML = html;

  // Récupérer le texte brut
  const text = temp.textContent || temp.innerText || '';

  // Nettoyer les espaces multiples et les retours à la ligne
  return text
    .replace(/\s+/g, ' ')
    .replace(/\n+/g, ' ')
    .trim();
};

/**
 * Tronque un texte à une longueur maximale
 * @param {string} text - Texte à tronquer
 * @param {number} maxLength - Longueur maximale
 * @returns {string} - Texte tronqué avec "..."
 */
export const truncateText = (text, maxLength = 150) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

/**
 * Combine stripHtml et truncateText
 * @param {string} html - Chaîne HTML
 * @param {number} maxLength - Longueur maximale
 * @returns {string} - Texte brut tronqué
 */
export const getCleanExcerpt = (html, maxLength = 150) => {
  const cleanText = stripHtml(html);
  return truncateText(cleanText, maxLength);
};
